/** OTP delivery channel labels — matches backend `delivery_channel` from /api/otp/send/ */

/** Shown on the phone-number screen (WhatsApp primary, SMS fallback). */
export const OTP_DELIVERY_NOTICE = 'Code is sent on WhatsApp / SMS';

export const OTP_WHATSAPP_ENTER_HINT = 'Code is sent on WhatsApp';

export const OTP_SMS_ENTER_HINT = 'Code is sent on SMS';

export const OTP_RESEND_NOTICE = 'New code sent on WhatsApp / SMS';

export const OTP_PASTE_EMPTY = 'No code to paste. Copy it from the latest message.';

export function formatOtpVerifyError(message, attemptsRemaining) {
  const base = (message || '').trim() || "That code didn't match. Copy the code from the latest message.";
  if (attemptsRemaining == null || Number.isNaN(Number(attemptsRemaining))) {
    return base;
  }
  const remaining = Number(attemptsRemaining);
  if (remaining <= 0) {
    return `${base} No tries left. Resend a new code.`;
  }
  return `${base} ${remaining} ${remaining === 1 ? 'try' : 'tries'} left.`;
}

export function normalizeOtpDeliveryChannel(value) {
  return value === 'whatsapp' ? 'whatsapp' : 'sms';
}

export function otpSendPrompt(_channel = 'whatsapp') {
  return OTP_DELIVERY_NOTICE;
}

export function otpSentPrompt(channel = 'sms') {
  return channel === 'whatsapp'
    ? 'We sent a 6-digit code on WhatsApp to'
    : 'We sent a 6-digit code by SMS to';
}

export function otpEnterHint(channel = 'sms') {
  return channel === 'whatsapp' ? OTP_WHATSAPP_ENTER_HINT : OTP_SMS_ENTER_HINT;
}
